import TaxExemptionsList from './TaxExemptionsList';

export default TaxExemptionsList;
